import { proxy } from 'valtio'

type DayAheadBidTableStore = {
  hasPendingEdits: boolean
  discardPendingEdits: (() => void) | null
  savePendingEdits: (() => void) | null
  isSavePending: boolean
}

export const dayAheadBidTableStore = proxy<DayAheadBidTableStore>({
  hasPendingEdits: false,
  discardPendingEdits: null,
  savePendingEdits: null,
  isSavePending: false,
})

export function registerDayAheadBidTablePendingEdits(
  hasPendingEdits: boolean,
  discard: (() => void) | null,
  save: (() => void) | null = null,
  isSavePending = false
): void {
  dayAheadBidTableStore.hasPendingEdits = hasPendingEdits
  dayAheadBidTableStore.discardPendingEdits = discard
  dayAheadBidTableStore.savePendingEdits = save
  dayAheadBidTableStore.isSavePending = isSavePending
}
